import dashboardTemplate from './dashboard.html';

export default angular
  .module('main.profile.tabs.dashboard', [])

  .directive('profileDashboardTab', () => {
    return {
      restrict: 'E',
      template: dashboardTemplate,
      scope: {},
      route: '/dashboard',
      controller: (
        $scope,
        $q,
        $filter,
        utils,
        ProfileDataProvider,
        ToastsService,
        config
      ) => {
        const $t = $filter('translate');
        $scope.dataProvider = ProfileDataProvider.instance;
        $scope.systemsOfMeasurement = config.getConfigByKey('systemsOfMeasurement');
        $scope.userInfo = {
          phoneNumber: '',
          phoneCode: '',
        };

        angular.extend($scope, {
          onSaveButtonClick: onSaveButtonClick,
          onCancelButtonClick: onCancelButtonClick,
        });

        init();

        function init() {
          $scope.loading = true;
          initForm();

          $q.all([
            $scope.dataProvider.userInfoResource.init(),
            $scope.dataProvider.userPermissionsStrResource.init(),
            $scope.dataProvider.availableLanguagesResource.init(),
            $scope.dataProvider.userSystemOfMeasurementResource.init(),
          ])
            .then(() => {
              initDataModel();
              initWatchers();
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initDataModel() {
          $scope.userOriginal = angular.copy($scope.dataProvider.userInfoResource.value?.user);
          $scope.user = angular.copy($scope.dataProvider.userInfoResource.value?.user);
          $scope.permissions = angular.copy($scope.dataProvider.userPermissionsStrResource.value);
          $scope.availableLanguages = angular.copy($scope.dataProvider.availableLanguagesResource.value);
          $scope.systemOfMeasurement = angular.copy($scope.dataProvider.userSystemOfMeasurementResource.value);

          // Parse phone number
          if ($scope.user.phone) {
            const phoneInfo = utils.parsePhoneNumber($scope.user.phone);
            if (phoneInfo.phoneNumber) {
              angular.extend($scope.userInfo, phoneInfo);
            }
          }
        }

        function initForm() {
          $.fn.form.settings.rules.phoneCode = function(value) {
            if (!!$scope.userInfo.phoneNumber || !!$scope.userInfo.phoneCode) {
              if (!$scope.userInfo.phoneCode || $scope.userInfo.phoneCode === '0' || !/^[0-9]{1,3}$/gi.test($scope.userInfo.phoneCode)) {
                return false;
              }
            }
            return true;
          };

          $.fn.form.settings.rules.phoneNumber = function(value) {
            if (!!$scope.userInfo.phoneNumber || !!$scope.userInfo.phoneCode) {
              if (!$scope.userInfo.phoneNumber || !/^[0-9]{7,14}$/gi.test($scope.userInfo.phoneNumber)) {
                return false;
              }
              return $.fn.form.settings.rules.phoneValidation(
                $scope.userInfo.phoneNumber,
                JSON.stringify({
                  code: $scope.userInfo.phoneCode.toString(),
                })
              );
            }
            return true;
          };

          $('#form-profile').form({
            inline: true,
            fields: {
              email: {
                identifier: 'email',
                rules: [
                  {
                    type: 'email',
                    prompt: $t('prompt.email.your')
                  }
                ]
              },
              firstname: {
                identifier: 'firstname',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.firstname')
                  }
                ]
              },
              lastname: {
                identifier: 'lastname',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.lastname')
                  }
                ]
              },
              code: {
                depends: 'phone',
                rules: [
                  {
                    type: 'phoneCode',
                    prompt: $t('prompt.signup.phone.code')
                  }
                ]
              },
              phone: {
                identifier: 'phone',
                rules: [
                  {
                    type: 'phoneNumber',
                    prompt: $t('prompt.signup.phone.invalid')
                  }
                ]
              },
              systemOfMeasurement: {
                identifier: 'systemOfMeasurement',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.empty')
                  }
                ]
              }
            }
          });
        }

        function initWatchers() {
          $('#profile-language').dropdown({
            onChange: function(value, text) {
              if (!value || $scope.loading) {
                return;
              }

              $scope.$applyAsync(() => {
                $scope.loading = true;
                $scope.dataProvider.changeUserLanguage(value)
                  .then((newLocale) => {
                    $scope.selectedLanguage = newLocale;
                    $scope.user.language = newLocale.code;
                    $scope.loading = false;

                    // Only if the language was changed
                    if (newLocale.code !== value) {
                      ToastsService.success(null, $t('profile.dashboard.change-language-success'));
                    }
                  }, (err) => {
                    utils.handleApiError(err);
                    $scope.loading = false;
                  });
              });
            }
          });
        }

        function onSaveButtonClick() {
          if ($scope.loading || !$scope.user) {
            return;
          }

          $('#form-profile').form('validate form');
          let isValid = $('#form-profile').form('is valid');
          if (!isValid) {
            return;
          }

          $scope.loading = true;

          // Save phone number only if it's not blank
          $scope.user.phone = $scope.userInfo.phoneNumber
            ? $scope.userInfo.phoneCode.toString() + $scope.userInfo.phoneNumber.toString()
            : '';

          // Reset phone type to mobile (default)
          $scope.user.phoneType = 1;

          $q.all([
            $scope.dataProvider.updateSystemOfMeasurement($scope.systemOfMeasurement),
            $scope.dataProvider.saveUser($scope.user)
          ])
            .then(() => {
              initDataModel();
              ToastsService.success(null, $t('profile.dashboard.save-user-success'));
              $scope.loading = false;
              $scope.dataProvider.reloadState();
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function onCancelButtonClick() {
          $scope.dataProvider.goBack();
        }

      }
    };
  })
  .name;
